export class FileRequestModel {
    app_id: string;
    UserId: string;
    parent_id: string;
    service_id: string;
    name: string;
    description: string;
}